import isEqual from 'lodash.isequal';
import partition from 'lodash.partition';
import React from 'react';
import {
  ApiMasterDataAdvancedQueryDimension,
  ApiMasterDataTypes,
} from './app/common/api/api-interfaces';
import { Filter } from './app/common/v2/common/components/filter/filterbar/types';
import {
  ApiMasterDataQueryFilterItem,
  DataFields,
  DataTypes,
} from './app/common/v2/types';

export type ClickEvent<ElementType = HTMLInputElement> =
  React.MouseEvent<ElementType>;

export interface DataFieldWithDataType {
  dataType: DataTypes;
  dataField: DataFields;
}

export interface IndexRange {
  startIndex: number;
  stopIndex: number;
}

export const getKeyFromDataFieldWithDataType = (
  d: DataFieldWithDataType
): string => {
  return `${d.dataType}+__+${d.dataField}`;
};

export const sameKindFiltersSplit = (
  filters: ApiMasterDataQueryFilterItem[],
  dimension: DataFieldWithDataType
): [ApiMasterDataQueryFilterItem[], ApiMasterDataQueryFilterItem[]] => {
  return partition(filters, (filter: ApiMasterDataQueryFilterItem) =>
    compareFilterToDim(filter, dimension)
  );
};

export const compareFilterToDim = (
  filter: ApiMasterDataQueryFilterItem | Filter,
  dimension: DataFieldWithDataType
) => isEqual(filterToDataFieldWithDataType(filter), dimension);

export const compareDimensionToDim = (
  dim: ApiMasterDataAdvancedQueryDimension,
  dimension: DataFieldWithDataType
) => isEqual(dimensionToDataFieldWithDataType(dim), dimension);

export const toDataFieldWithDataType = (
  dataType: ApiMasterDataTypes | DataTypes,
  field: string
) => ({
  dataType: dataType as DataTypes,
  dataField: field as DataFields,
});

export const dimensionToDataFieldWithDataType = (
  dimension: ApiMasterDataAdvancedQueryDimension
) => ({
  dataType: dimension.dataType as DataTypes,
  dataField: dimension.property as DataFields,
});

export const filterToDataFieldWithDataType = (
  filter: ApiMasterDataQueryFilterItem | Filter
) => ({
  dataType: filter.dataType as DataTypes,
  dataField: filter.property as DataFields,
});

export const toAdvancedDimension: (
  dataFieldWithDataType: DataFieldWithDataType
) => ApiMasterDataAdvancedQueryDimension = (
  dataFieldWithDataType: DataFieldWithDataType
) => ({
  dataType: dataFieldWithDataType.dataType,
  property: dataFieldWithDataType.dataField,
});

export interface Constructable<T> {
  new (...args: any): T;
}
